"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormLabelField = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _RequiredSign = require("../RequiredSign");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const FormLabelField = (param)=>{
    let { label, required } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.Typography, {
        color: "textPrimary",
        fontWeight: "bold",
        "data-testid": getTestId(_constants.FORM_LABEL),
        children: [
            label,
            required ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_RequiredSign.RequiredSign, {}) : null
        ]
    });
};
exports.FormLabelField = FormLabelField;
